export enum InventoryOutputTypeEnums {
  output = 1,
  transfer = 2,
  replacement = 3,
  invoice = 4,
  salesRemission = 5
}